import { Directionality } from '@angular/cdk/bidi';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { OrderStatus } from '@dss-libs/shared/type/common-types';
import { OrderStatusTranslationMapper } from '@dss-libs/portal/type/portal-types';
import {
  getOrderStatusColor,
  getOrderStatusIcon,
  getOrderStatusOnHoverClasses,
} from '@dss-libs/portal/utility/portal-utility-services';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { TranslocoDecimalPipe } from '@jsverse/transloco-locale';

@Component({
  selector: 'dss-libs-feature-order-status-cell',
  imports: [MatIcon, TranslocoDirective, TranslocoPipe, TranslocoDecimalPipe],
  templateUrl: './order-status-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderStatusCellComponent {
  readonly #directionality = inject(Directionality);
  readonly status = input.required<OrderStatus>();
  readonly completedCount = input<number>();
  readonly recipientsCount = input<number>();
  readonly onClick = input<() => void>();

  protected readonly orderStatus = OrderStatus;
  protected readonly isRtl = computed(() => this.#directionality.valueSignal() === 'rtl');
  protected readonly statusIcon = computed(() => getOrderStatusIcon(this.status()));
  protected readonly statusColor = computed(() => getOrderStatusColor(this.status()));
  protected readonly statusHoverClasses = computed(() => getOrderStatusOnHoverClasses(this.status()));
  protected readonly statusLabelKey = computed(() => OrderStatusTranslationMapper.get(this.status()));
}
